<template>
    <Card :title="$t('labels.currencies')">
        <template #header-elements>
            <AlphaButton color="teal" class="mr-2" @click="showAddCurrencyModal">
                <span>{{ $t('buttons.add') }}</span>
            </AlphaButton>
        </template>
        <DataTable
            ref="table"
            :url="table.url"
            :columns="table.columns"
            :check-box-props="false"
            :search-props="false"
            :pagination-props="false"
            @selectRow="row => $refs.editCurrencyModal.show(row.currency_id)"
        >
            <template #row-main="{row}">
                <Radio :model-value="row.main" :disabled="true"/>
            </template>
        </DataTable>
    </Card>
    <AddCurrencyModal ref="addCurrencyModal" @created="$refs.table.load()"/>
    <EditCurrencyModal ref="editCurrencyModal" @updated="$refs.table.load()" @deleted="$refs.table.load()"/>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import AlphaButton from '../../../../../components/new/button/AlphaButton.vue';
import DataTable from '../../../../../components/table/DataTableComponent.vue';
import Radio from '../../../../../components/new/form/radio/Radio.vue';
import AddCurrencyModal from '../modals/AddCurrencyModal.vue';
import EditCurrencyModal from '../modals/EditCurrencyModal.vue';

export default {
    name: "CurrenciesCard",
    components: {
        Card, AlphaButton, DataTable, Radio, AddCurrencyModal, EditCurrencyModal
    },
    data() {
        return {
            table: {
                url: '/settings/basic/currencies/table',
                columns: [
                    {
                        name: "main",
                        data: "main",
                        width: "80px",
                        searchable: 0,
                        orderable: false,
                        field: this.$t('table.titles.main')
                    },
                    {
                        name: "name",
                        data: "name",
                        width: "auto",
                        searchable: 0,
                        orderable: false,
                        field: this.$t('table.titles.name')
                    },
                    {
                        name: "rate",
                        data: "rate",
                        width: "100px",
                        searchable: 0,
                        orderable: false,
                        field: this.$t('table.titles.rate')
                    }
                ]
            }
        }
    },
    methods: {
        showAddCurrencyModal() {
            let attachedCurrencyUuids = this.$refs.table.rows.map(row => row.currency_uuid);

            this.$refs.addCurrencyModal.show(attachedCurrencyUuids);
        }
    }
}
</script>
